import { render, staticRenderFns } from "./ResumenLink.vue?vue&type=template&id=3ca90c34&lang=pug&"
import script from "./ResumenLink.vue?vue&type=script&lang=js&"
export * from "./ResumenLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports